import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "teknikdestek";
var destekService = {
    destekTalebi(mesaj, resim) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                mesaj: mesaj,
                resim: resim,
                methodName: "destek"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    }
}

export default destekService

